import { type ReactNode } from 'react';

interface LoadingIndicatorProps {
  isLoading: boolean;
  children: ReactNode;
  message?: string;
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
}

export const LoadingIndicator = ({
  isLoading,
  children,
  message = 'Loading...',
  size = 'medium',
  fullScreen = false,
}: LoadingIndicatorProps) => {
  if (!isLoading) {
    return <>{children}</>;
  }

  const spinnerSizeClass = {
    small: 'w-4 h-4 border-2',
    medium: 'w-8 h-8 border-3',
    large: 'w-12 h-12 border-4',
  }[size];

  const containerClass = fullScreen
    ? 'fixed inset-0 bg-white bg-opacity-80 z-50 flex items-center justify-center'
    : 'loading-indicator';

  return (
    <div className={containerClass}>
      <div className={`loading-spinner ${spinnerSizeClass}`} />
      {message && <p>{message}</p>}
    </div>
  );
};